import { FC, ReactElement, useState } from 'react';

import { AccountTabHeader, TabList } from '../../../../../compositions';
import { ConnectedAccountDashboardConfig, ConnectedOrderOverview } from '../../../../../connectors';
import { OrderOverviewType } from '../../../../../entities/@account/OrderOverview/OrderOverview';
import { useTrans } from '../../../../../hooks';

import './AccountDashboardTab.scss';

export const AccountDashboardTab: FC = (): ReactElement => {
    const trans = useTrans();

    const [activeOrderTab, setActiveOrderTab] = useState<OrderOverviewType>(OrderOverviewType.online);

    const tabs = [
        { label: trans('pages.account.tabs.dashboard.recentOrders.onlineOrders'), value: OrderOverviewType.online },
        // TODO: Enable when in store purchases are retrievable — it'll just work after uncommenting the next line
        // { label: trans('pages.account.tabs.dashboard.recentOrders.inStoreOrders'), value: OrderOverviewType.inStore },
    ];

    const handleSelectOrderTab = (value: string): void => {
        setActiveOrderTab(value as OrderOverviewType);
    };

    return (
        <div className="account-dashboard-tab">
            <AccountTabHeader
                title={trans('pages.account.tabs.dashboard.title')}
                description={trans('pages.account.tabs.dashboard.description')}
            />

            <div className="account-dashboard-tab__recent-orders">
                <h2 className="account-dashboard-tab__heading">
                    {trans('pages.account.tabs.dashboard.recentOrders.title')}
                </h2>

                <TabList
                    tabs={tabs}
                    activeTab={activeOrderTab}
                    onTabSelect={handleSelectOrderTab}
                    className="account-dashboard-tab__tab-list"
                    tabItemLabelClassName="account-dashboard-tab__tab-item-label"
                />

                <ConnectedOrderOverview
                    overviewType={activeOrderTab}
                    pageSize={3}
                    className="account-dashboard-tab__order-overview"
                />
            </div>

            <div className="account-dashboard-tab__configuration-section">
                <ConnectedAccountDashboardConfig />
            </div>
        </div>
    );
};
